/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ArchivingGkReportOverviewDTO } from '../model/models';
import { ArchivingGkReportResponseDTO } from '../model/models';
import { ReportStatusDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GenerateArchivingGkReportRequestParams {
    usageMonth: string;
}

export class ClsGenerateArchivingGkReportRequestParams {
    usageMonth: string = undefined;
}

export interface GetArchivingGkCsvReportRequestParams {
    usageMonth: string;
}

export class ClsGetArchivingGkCsvReportRequestParams {
    usageMonth: string = undefined;
}

export interface GetArchivingGkReportRequestParams {
    usageMonth: string;
}

export class ClsGetArchivingGkReportRequestParams {
    usageMonth: string = undefined;
}

export interface GetArchivingGkReportOverviewRequestParams {
    usageMonth: string;
}

export class ClsGetArchivingGkReportOverviewRequestParams {
    usageMonth: string = undefined;
}

export interface GetReportStatusGkReportRequestParams {
    usageMonth: string;
}

export class ClsGetReportStatusGkReportRequestParams {
    usageMonth: string = undefined;
}


export interface AdminArchivingGkReportApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Generate an archiving GK usage report for all existing all tenants
     * This function will generate archiving GK usage report for all existing tenants. 
* @param requestParameters
     */
    generateArchivingGkReport(requestParameters: GenerateArchivingGkReportRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Download the generated archiving GK usage CSV report for all existing tenants
     * Download the generated archiving GK usage CSV report for all existing tenants. 
* @param requestParameters
     */
    getArchivingGkCsvReport(requestParameters: GetArchivingGkCsvReportRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Download the generated archiving GK usage report for all existing tenants
     * Download the generated archiving GK report for all existing tenants. 
* @param requestParameters
     */
    getArchivingGkReport(requestParameters: GetArchivingGkReportRequestParams, extraHttpRequestParams?: any): Observable<ArchivingGkReportResponseDTO>;

    /**
     * Return overview of archiving GK usage report for all existing tenants
     * Returns overview of archiving GK usage report. This overview is generated with GK usage report ( /admin/gk-report/{usageMonth} ) so this report has to be generated no data are provided. 
* @param requestParameters
     */
    getArchivingGkReportOverview(requestParameters: GetArchivingGkReportOverviewRequestParams, extraHttpRequestParams?: any): Observable<ArchivingGkReportOverviewDTO>;

    /**
     * Status of generating an archiving GK usage report
     * Status of generating an archiving GK usage report for all existing tenants. 
* @param requestParameters
     */
    getReportStatusGkReport(requestParameters: GetReportStatusGkReportRequestParams, extraHttpRequestParams?: any): Observable<ReportStatusDTO>;

}
